<script setup lang="ts">
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const props = defineProps<{
  isPending: boolean;
}>();
const isOr = defineModel<boolean>();
</script>

<template>
  <div class="d-flex align-center justify-center and-or-switch" data-test-id="filter-and-or-switch">
    <p>{{ t('common.and') }} / {{ t('common.or') }}</p>
    <v-switch
      v-model="isOr"
      :disabled="props.isPending"
      color="primary"
      hide-details
      sentry-unmask
    />
  </div>
</template>

<style lang="scss" scoped>
.and-or-switch {
  position: relative;
  width: 3rem;

  .v-switch {
    padding-top: 0.5rem;
  }

  p {
    position: absolute;
    top: 0;
    margin: 0;
    left: -2px;
    white-space: nowrap;
  }
}
</style>
